import script from "./MessageAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageAudio.vue?vue&type=script&setup=true&lang=js"

import "./MessageAudio.vue?vue&type=style&index=0&id=1c0de7ba&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0de7ba"]])

export default __exports__